import { IS_DEV, IS_XAGENT } from "@/constants/common";
import axios from "axios";
import xagentJson from "~/xagent.json";

const ASSETS_MAP: any = {};

export function getAssetUrl(url: string, wrap: boolean | string = false) {
  let re;

  if (!IS_XAGENT && !IS_DEV) {
    if (!ASSETS_MAP[url]) {
      let userData = xagentJson?.applicationInfo?.materialInfo?.userData;

      if (userData) {
        let finded: any = userData.find((item: any) => item.key === url);

        if (finded) {
          ASSETS_MAP[url] = finded.value;
        } else {
          console.error(`未在xagent.json中未找到${url}，请确认资源是否上传！`);
        }
      } else {
        console.error(
          "未在xagent.json中未找到userData字段，请确认配置文件是否正常！"
        );
      }
    }

    re = ASSETS_MAP[url];
  } else {
    re = `./${url}`;
  }

  return wrap ? `${wrap}(${re})` : re;
}

export function loadFonts(fonts: any[]) {
  let promises = [];

  for (let i = 0; i < fonts.length; i++) {
    let font: any = fonts[i];

    promises.push(
      new FontFace(font[0], font[1], font[2]).load().then((re) => {
        document.fonts.add(re);
      })
    );
  }

  return Promise.allSettled(promises);
}

export function loadJSON(url: string) {
  return fetch(url)
    .then((re) => {
      return re.json();
    })
    .catch((e) => {
      console.error(`加载${url}数据失败！`, e);
    });
}

export async function request(
  axiosOptions: any = {},
  options = { setLocal: true, localKey: "local" }
) {
  let result: any;
  const localData = localStorage.getItem(options.localKey);

  try {
    await axios(axiosOptions).then((re) => {
      result = re?.data;

      // 有数据且请求成功
      if (result?.data && result?.success) {
        if (options.setLocal) {
          localStorage.setItem(options.localKey, JSON.stringify(re.data));
        }
      } else {
        // 失败
        console.error(
          `request-${axiosOptions.url}-接口请求失败，无data或者success为false`,
          result
        );

        if (localData) {
          result = JSON.parse(localData);
        }
      }
    });
  } catch (e: any) {
    // 错误
    console.error(
      `request-${axiosOptions.url}-接口请求错误，${e?.message}，status-${e?.response?.status}`,
      e
    );

    if (localData) {
      result = JSON.parse(localData);
    }
  }

  return result;
}

export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function getTransformInfo(element: HTMLElement) {
  const style = window.getComputedStyle(element);
  const transform: any = style.getPropertyValue("transform");

  let scaleX, scaleY, translateX, translateY;

  if (transform && transform.indexOf("matrix") === 0) {
    const values = transform
      .match(/matrix\((.+)\)/)[1]
      .split(", ")
      .map(Number);

    scaleX = values[0];
    scaleY = values[3];
    translateX = values[4];
    translateY = values[5];
  } else {
    // 如果transform属性没有matrix值（例如，它可能是'none'或一个3D transform），我们可以为缩放和平移设置默认值
    scaleX = 1;
    scaleY = 1;
    translateX = 0;
    translateY = 0;
  }

  return {
    scaleX: scaleX,
    scaleY: scaleY,
    translateX: translateX,
    translateY: translateY,
  };
}

export function toFullWidth(str?: string) {
  if (str) {
    let result = "";
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i);

      if ([33, 34, 39, 40, 41, 44, 58, 59, 63].indexOf(charCode) > -1) {
        result += String.fromCharCode(charCode + 65248); // 将半角字符转换为全角
      } else {
        result += str[i];
      }
    }
    return result;
  } else {
    return str;
  }
}
